import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function HeroBackgroundOverlay() {
  return <section data-section-id="255918" id="uvjeti-korištenja" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/legal_terms_background.png')]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-primary/20 bg-gradient-to-b from-primary/40 to-background/80" />

      {}
      <div className="relative z-10 bg-background/90 backdrop-blur-md p-8 md:p-16 rounded-lg shadow-3xl max-w-4xl mx-4 w-full flex flex-col items-center text-center border border-primary/10">
        
        <h1 className="font-default text-3xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tight mb-6">
          Uvjeti korištenja
        </h1>

        <p className="font-default text-base md:text-lg text-muted-foreground mb-10 max-w-2xl leading-relaxed">
          Ovi uvjeti uređuju vaš pristup i korištenje naših web stranica i usluga. Molimo vas da ih pažljivo pročitate prije nastavka.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-10 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-md px-8 text-base bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
            <Link to="/PrivacyPolicyPage">
              Politika privatnosti
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-md px-8 text-base bg-transparent border-primary/30 text-primary hover:bg-primary/5">
            <Link to="/ContactUsPage">
              Kontaktirajte nas
            </Link>
          </Button>
        </div>

        {}
        <nav className="flex flex-wrap justify-center gap-6 text-sm font-default text-muted-foreground pt-6 border-t border-border w-full">
          <Link to="/HomePage" className="hover:text-primary transition-colors">
            Početna
          </Link>
          <Link to="/FeaturesPage" className="hover:text-primary transition-colors">
            Značajke
          </Link>
          <Link to="/PricingPage" className="hover:text-primary transition-colors">
            Pricing
          </Link>
        </nav>
        
      </div>
    </section>;
}